import { render, staticRenderFns } from "./VesselMachineTable.vue?vue&type=template&id=6f89b30b&scoped=true&"
import script from "./VesselMachineTable.vue?vue&type=script&lang=js&"
export * from "./VesselMachineTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f89b30b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
